import { InProcessGatherJsonResponse } from "../../common/model/gtr/jsonResponse";
import { createCommonJsonResponse } from "../objectTypeConstants";

export const inProcessGatherJsonResponse: InProcessGatherJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        clientName: "string",
        clientId: "string",
        eroSigner: "string",
        officeLocation: "string",
        assignedTo: "string",
        status: 3,
        date: "DD/MM/YYYY HH:MM:SS",
        engagementType: 0,
        taxYear: 2023,
        gatherId: 0,
    }]
}